import React from 'react';
import { IconProps, IconWrap } from './IconWrap';

export const IconChevronRight = ({
    color = '#44527B',
    width = 4,
    height = 7,
    iconClass,
    ...props
}: IconProps) => {
    return (
        <IconWrap
            {...props}
            viewBox="0 0 4 7"
            width={width}
            height={height}
            iconClass={iconClass || 'chevron-right'}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.200095 0.25283C0.393973 0.0589526 0.70831 0.0589525 0.902187 0.25283L3.79817 3.14881C3.89127 3.24191 3.94358 3.36819 3.94358 3.49986C3.94358 3.63152 3.89127 3.7578 3.79817 3.8509L0.902187 6.74688C0.70831 6.94076 0.393973 6.94076 0.200095 6.74688C0.00621817 6.553 0.00621821 6.23867 0.200096 6.04479L2.74503 3.49986L0.200096 0.954922C0.00621821 0.761044 0.00621817 0.446707 0.200095 0.25283Z"
                fill={color}
            />
        </IconWrap>
    );
};

export const IconChevronLeft = ({ style, ...props }: IconProps) => {
    return (
        <IconChevronRight
            {...props}
            style={{ ...style, transform: 'rotateZ(180deg)' }}
            iconClass="chevron-left"
        />
    );
};

export const IconChevronUp = ({ style, ...props }: IconProps) => {
    return (
        <IconChevronRight
            {...props}
            style={{ ...style, transform: 'rotateZ(270deg)' }}
            iconClass="chevron-up"
        />
    );
};

export const IconChevronDown = ({ style, ...props }: IconProps) => {
    return (
        <IconChevronRight
            {...props}
            style={{ ...style, transform: 'rotateZ(90deg)' }}
            iconClass="chevron-down"
        />
    );
};
